import React from 'react';
import { Skeleton as AntSkeleton } from 'antd';
import Card from '../Card/Card';

/**
 * Reusable loading placeholder.
 *
 * @param {object}  props
 * @param {number}  [props.rows=3]
 * @param {boolean} [props.avatar=false]
 * @param {boolean} [props.card=false]   - wraps content in a Card if true
 */
const Skeleton = ({ rows = 3, avatar = false, card = false }) => {
  const content = (
    <AntSkeleton active avatar={avatar} paragraph={{ rows }} />
  );
  return card ? <Card>{content}</Card> : content;
};

export default Skeleton;
